import { render, staticRenderFns } from "./NewDepartmentDialog.vue?vue&type=template&id=0bcf58a4&"
import script from "./NewDepartmentDialog.vue?vue&type=script&lang=js&"
export * from "./NewDepartmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewDepartmentDialog.vue"
export default component.exports